export enum ElementTemplateListColId {
  ACTIONS = 'actions',
  CUSTOM_IDENTIFIER = 'customIdentifier',
  DESCRIPTION = 'description',
  OWNER = 'owner',
  UPDATED_AT = 'updatedAt',
  UPDATED_BY = 'updatedBy',
}
